import { css } from 'aphrodite';
import { Tooltip as TooltipPrimitive } from 'radix-ui';
import * as React from 'react';
import { s } from './styles';

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
	React.ElementRef<typeof TooltipPrimitive.Content>,
	AphroditeStyled<React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>>
>(({ sideOffset = 4, styles = [], ...props }, ref) => (
	<TooltipPrimitive.Portal>
		<TooltipPrimitive.Content ref={ref} sideOffset={sideOffset} className={css(s.content, ...styles)} {...props} />
	</TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

function SimpleTooltip({
	title,
	asChild = true,
	styles = [],
	delayDuration,
	...props
}: React.ComponentProps<typeof TooltipTrigger> & {
	title: React.ReactNode;
	styles?: AphroditeStyled<any>['styles'];
	delayDuration?: number;
}) {
	return (
		<Tooltip delayDuration={delayDuration}>
			<TooltipTrigger asChild={asChild} {...props} />
			<TooltipContent styles={styles}>{title}</TooltipContent>
		</Tooltip>
	);
}

export { SimpleTooltip, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
